import React from "react";

export default function History_Intelligence() {
  return (
    <div>
      <h1>History_Intelligence</h1>
      <p>This is the History_Intelligence component.</p>
    </div>
  );
}
